import { ScannerConnectionFailureReason, ScannerFailurePolicy } from 'models/QRCodeScannerDevice/types';

export const NEWLAND_VENDOR_ID = 7851;
// HID POS "Bar Code Scanner" usage page (0x8C): the interface sending decoded data, whatever the scanner model
export const HID_POS_USAGE_PAGE = 140;

export const LOG_PREFIX = '[QR Code HID] -';

export const RETRY_DELAY_MS = 1000;
// The scanner can show up a few seconds after page load (kiosk boot, USB enumeration): wait before reporting
export const ATTEMPTS_BEFORE_REPORT = 10;

export const FAILURE_POLICIES: Record<ScannerConnectionFailureReason, ScannerFailurePolicy> = {
  [ScannerConnectionFailureReason.WEBHID_UNAVAILABLE]: { isReportedImmediately: true, isPermanent: true },
  [ScannerConnectionFailureReason.NO_ALLOWED_HID_DEVICE]: { isReportedImmediately: false, isPermanent: false },
  [ScannerConnectionFailureReason.SCANNER_VENDOR_NOT_FOUND]: { isReportedImmediately: false, isPermanent: false },
  [ScannerConnectionFailureReason.NO_HID_POS_INTERFACE]: { isReportedImmediately: false, isPermanent: false },
  [ScannerConnectionFailureReason.OPEN_FAILED]: { isReportedImmediately: true, isPermanent: false },
  [ScannerConnectionFailureReason.GET_DEVICES_FAILED]: { isReportedImmediately: true, isPermanent: false },
  [ScannerConnectionFailureReason.UNEXPECTED_ERROR]: { isReportedImmediately: true, isPermanent: false },
};
